import { DataCache, SharedKeyRelationship } from 'lib/DataCache';

import { PortCallScheduleResponse } from 'data/models/PortCallScheduleResponse';

import { PCCache, PCCollection } from 'data/PCCache';

export class PortCallScheduleCache extends DataCache {
    PortCallScheduleResponses = PCCollection(PortCallScheduleResponse);

    constructor(data : PCCache) {
        super();

        new SharedKeyRelationship(this.PortCallScheduleResponses, data.PortCalls, r => r.PortCall, null);
    }
}



// WEBPACK FOOTER //
// ./apps/portcall/portcallschedule/cache.ts